export default "__VITE_ASSET__DgCc88xZ__"